module.exports = __webpack_public_path__ + "static/media/pmi.f08251e8.png";